module.exports = __webpack_public_path__ + "static/media/HCMM847.2f93b83d.jpg";